import React, { useState, useEffect } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { firebase } from "../../Firebase";
import SummaryBox from "../../components/SummaryBox/SummaryBox";

const noErrors = {
  mobile_site_speed: 0,
  non_ssl_site: 0,
  site_speed: 0,
  ssl_expiration: 0,
  status: 0
};

function ErrorCounts() {
  const counters = firebase
    .firestore()
    .collection("counters")
    .doc("aggregate");
  const [errorCount, setErrorCount] = useState({ ...noErrors });

  const [value] = useCollection(counters, {
    snapshotListenOptions: { includeMetadataChanges: true }
  });

  useEffect(() => {
    if (value !== undefined) {
      setErrorCount(value.data());
    }
  }, [value]);

  return (
    <div className="summaries">
      <SummaryBox
        title="Non-200 Responses"
        noun="Sites"
        value={errorCount.status}
        tooltipText={`These are approximate numbers that <br/>
        are calculated at the beginning <br/> 
        of the day, any changes to the data <br/>
        will be reflected in tomorrow morning's calculation.`}
      />
      <SummaryBox
        title="SSL Status"
        noun="Expiring Soon"
        value={errorCount.non_ssl_site}
        tooltipText={`These are approximate numbers that <br/>
        are calculated at the beginning of the day. <br/>
        Note: default filtering orders expiring SSL's first.<br/>
        To find Non-ssl sites enter the filter: <br/>
        SSL Expiration == Non-SSL Site`}
      />
      <SummaryBox
        title="Site Speed"
        noun="Under 85"
        value={errorCount.site_speed}
        tooltipText={`These are approximate numbers that <br/>
        are calculated at the beginning <br/> 
        of the day, any changes to the data <br/>
        will be reflected in tomorrow morning's calculation.`}
      />
      <SummaryBox
        title="Total Sites"
        noun="Sites"
        value={errorCount.total_sites}
        tooltipText={`These are approximate numbers that <br/>
        are calculated at the beginning <br/> 
        of the day, any changes to the data <br/>
        will be reflected in tomorrow morning's calculation.`}
      />
    </div>
  );
}

export default ErrorCounts;
